import { render, staticRenderFns } from "./NewPressNewForm.vue?vue&type=template&id=31712155"
import script from "./NewPressNewForm.vue?vue&type=script&lang=js"
export * from "./NewPressNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports